export const themes = {
  light: {
    colors: {
      avocado: 'rgba(150, 220, 130, 1)',
      cashew: 'rgba(240, 237, 209, 1)',
      cornflower: 'rgba(101, 104, 214, 1)',
      cream: 'rgba(250, 251, 255, 1)',
      marigold: 'rgba(255, 229, 123, 1)',
      pumpkin: 'rgba(199, 125, 240, 1)',
      pumpkinbutter: 'rgba(219, 145, 255, 1)',
      tomato: 'rgba(153, 1, 235, 1)',
      panther: 'rgba(251, 113, 133, 1)',
      pantherbutter: 'rgba(251, 143, 173, 1)',
      white: 'rgba(255, 255, 255, 1)',
      cornbutter: 'rgba(176, 179, 234, 1)',
      cool: {
        '20': 'rgba(221, 248, 240, 1)',
        '30': 'rgba(212, 236, 231, 1)',
        '40': 'rgba(178, 217, 209, 1)',
        '60': 'rgba(150, 182, 179, 1)',
        '80': 'rgba(125, 152, 147, 1)',
        '100': 'rgba(85, 103, 100, 1)',
      },
      warm: {
        '5': 'rgba(242, 241, 247, 1)',
        '10': 'rgba(237, 236, 243, 1)',
        '30': 'rgba(204, 201, 216, 1)',
        '50': 'rgba(130, 125, 150, 1)',
        '75': 'rgba(81, 79, 103, 1)',
        '90': 'rgba(47, 46, 57, 1)',
      },
    },
    background: {
      base: 'var(--colors-cream)',
      button: 'var(--colors-cornflower)',
      dark: '#222',
      feedback: '#f4e6fc',
      highlight: 'rgba(255, 229, 123, 0.2)', // marigold with alpha
      hint: '#e6eefe',
      input: 'var(--colors-warm-10)',
      layout: 'var(--colors-warm-5)',
      secondary: 'var(--colors-warm-5)',
      success: 'var(--colors-cool-20)',
      error: 'rgba(244, 111, 196, 0.3)',
      well: '#c9ccd7',
    },
    text: {
      base: 'var(--colors-warm-90)',
      warm: 'var(--colors-warm-90)',
      button: 'var(--colors-warm-90)',
      light: 'var(--colors-white)',
    },
    border: {
      button: '#9eff61',
      input: 'var(--colors-warm-30)',
      separator: 'var(--colors-warm-30)',
      strong: '#333',
    },
    spacing: {
      base: '1rem',
    },
    scrollbars: {
      color: '#ddd',
      hover: '#333',
      size: '12px',
    },
    font: {
      size: {
        input: '13px',
        text: '15px',
        title: '18px',
      },
      family: {
        input: "'Inter', Helvetica Neue', 'Arial Nova', Helvetica, Arial, sans-serif",
        text: "'Inter','Helvetica Neue', 'Arial Nova', Helvetica, Arial, sans-serif",
        title: "'Inter','Helvetica Neue', 'Arial Nova', Helvetica, Arial, sans-serif",
      },
      weight: {
        input: 500,
        text: 400,
        title: 600,
      },
    },
    components: {
      header: {
        background: 'var(--background-base)',
      },
      footer: {
        background: 'var(--background-base)',
      },
      avatar: {
        background: 'var(--colors-cool-30)',
      },
      tutor: {
        background: 'var(--colors-warm-5)',
      },
      bubbles: {
        hint: {
          background: 'var(--colors-cashew)',
          text: 'var(--text-base)',
        },
        error: {
          background: 'var(--background-error)',
          text: 'var(--text-base)',
        },
        success: {
          background: 'var(--background-success)',
          text: 'var(--text-base)',
        },
        secondary: {
          background: 'var(--colors-cool-20)',
          text: 'var(--text-base)',
        },
        content: {
          background: 'var(--colors-marigold)',
          text: 'var(--text-base)',
        },
        tutor: {
          background: 'var(--colors-cool-30)',
          text: 'var(--colors-warm-90)',
        },
        coach: {
          background: 'var(--background-hint)',
          text: 'var(--colors-warm-90)',
        },
        model: {
          background: 'var(--colors-warm-90)',
          text: 'var(--colors-warm-90)',
        },
        user: {
          background: 'var(--background-input)',
          text: 'var(--text-base)',
        },
      },
    },
  },
  dark: {},
};
